<template>
    <div style="padding: 1vw">
        <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
            <div class="pageTitle">
                <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
                    시술동의서 조회
                </h3>
                <span class="pageDesc">
                    병원에서 등록한 시술동의서를 볼 수 있습니다.
                </span>
            </div>
            <div style="display: flex; align-items: center;">
            </div>
        </div>
        <div class="container-wrapper">
            <div class="search-filter-container table-info-filter">
                <!-- 직원명 검색 영역 -->
                <div class="search-filter-row">
                    <div class="search-filter-title">
                        검색어
                    </div>
                    <div class="search-filter-content search-keyword-area">
                        <select class="search-select" v-model="searchForm.filter">
                            <option value="">전체</option>
                            <option value="name">환자명</option>
                            <option value="phone">전화번호</option>
                            <option value="hospitalName">병원명</option>
                        </select>
                        <div class="search-input-container">
                            <div class="search-icon">
                                <i class="fa-regular fa-magnifying-glass"/>
                            </div>
                            <a-input
                                style="width: 220px"
                                type="text"
                                class="search-input-text"
                                v-model:value="searchForm.keyword"
                                placeholder="검색어를 입력하세요"
                                @pressEnter="handleSearch"
                            >
                            </a-input>
                        </div>
                        <a-button
                            class="search-btn-filter"
                            @click="handleSearch"
                        >
                            검색
                        </a-button>
                        <a-button
                            class="init-btn"
                            @click="handleReset"
                        >
                            초기화
                        </a-button>
                    </div>
                </div>
                    <!-- 동의서상태 선택 영역 -->
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            동의서상태
                        </div>
                        <div class="search-filter-content">
                            <a-select
                                v-model:value="searchForm.status"
                                style="width: 200px"
                                @change="handleSearch"
                                placeholder="동의서 상태 선택"
                            >
                                <a-select-option :value="null">전체</a-select-option>
                                <a-select-option value="CONTRACT_CREATED">서명진행중</a-select-option>
                                <a-select-option value="SIGNATURE_CONCLUDED">서명완료</a-select-option>
                            </a-select>
                        </div>
                    </div>
        
                    <!-- 동의서일자 선택 영역 -->
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            동의서 작성일자
                        </div>
                        <div class="search-filter-content">
                            <div class="date-range">
                            <a-range-picker
                                v-model:value="dateRange"
                                style="width: 280px"
                                @change="handleDateChange"
                                :placeholder="['시작일', '종료일']"
                                :format="'YYYY-MM-DD'"
                                :allowClear="true"
                                :disabled-date="disabledDate"
                                :locale="locale"
                            />
                            </div>
                        </div>
                    </div>
                    <div class="search-filter-row">
                        <div class="search-filter-title">
                            테스트 병원 여부
                        </div>
                        <div class="search-filter-content">
                            <a-checkbox v-model:checked="searchForm.excludeTestHospital">
                            테스트 병원 제외
                            </a-checkbox>
                        </div>
                    </div>
              </div>
        </div>
        <div class="container-wrapper">
            <div class="col-xs-12 table-info-filter">
                <div class="total-div">
                    <p>
                    전체 <span>{{ formatCommaNumber(total) }}</span>건
                    </p>
                </div>
                <div class="search-container">
                    <a-select
                        v-model:value="pageSize"
                        style="width: 120px"
                        @change="handleSizeChange"
                    >
                        <a-select-option :value="10">10개씩 보기</a-select-option>
                        <a-select-option :value="20">20개씩 보기</a-select-option>
                        <a-select-option :value="50">50개씩 보기</a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
        <div class="container-wrapper">
            <a-table
                :loading="loading"
                :columns="columns"
                :data-source="contractList"
                :pagination="false"
                :locale="{ emptyText: '데이터가 없습니다.' }"
                row-key="id"
            />
        </div>
        <pagination
            v-if="total > 0"
            :page-info="paginationData"
            @change-page="paginationHandler"
        />

    </div>
</template>
<script>
import { formatCommaNumber, phoneNumberFormatter } from '@/utils/utils';
import CardContainer from "@/views/components/CardContainer.vue";
import PageHeader from "@/views/components/PageHeader.vue";
import Pagination from '@/views/components/Pagination.vue';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { Button, DatePicker, Input, Select, Table } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import { defineComponent } from 'vue';
import { PrixContractApi } from './api';

export default defineComponent({
    name: 'ConsentContracts',
    components: {
        PageHeader,
        CardContainer,
        ASelect: Select,
        ASelectOption: Select.Option,
        AButton: Button,
        AInput: Input,
        ARangePicker: DatePicker.RangePicker,
        ATable: Table,
        Pagination,
    },
    computed: {
        columns() {
            let cols = [...this.baseColumns];
            
            // 번호 컬럼 추가
            cols.unshift({
                title: '번호',
                key: 'index',
                width: 70,
                align: 'center',
                customRender: ({index}) => {
                    // 내림차순 번호 계산 (전체 항목 수에서 역순으로 계산)
                    return this.total - ((this.current - 1) * this.pageSize + index);
                }
            });
    
            // 체크박스 컬럼 추가
            if (this.isCheckboxVisible) {
                cols.unshift({
                    title: () => {
                    const deleteCount = this.contractList.filter(item => item.isChecked).length;
                        return (
                            <div>
                            <span>{deleteCount}개 선택됨</span><br/>
                            <a-checkbox 
                                style={{cursor: "pointer", marginLeft: '8px'}}
                                onChange={(e) => {
                                const checkValue = e.target.checked;
                                this.contractList.forEach(item => {
                                    item.isChecked = checkValue;
                                });
                                }}
                            />
                            </div>
                        );
                    },
                    key: 'selection',
                    width: 80,
                    customRender: ({record}) => {
                        return (
                            <a-checkbox 
                                checked={record.isChecked}
                                onChange={(e) => record.isChecked = e.target.checked}
                            />
                        );
                    },
                    align: 'center'
                });
            }
            return cols;
        },
    },
    data() {
        return {
            locale,
            dayjs,
            formatCommaNumber,

            searchForm: {
                status: null,           // 빈 문자열 대신 null
                keyword: '',             // 문자열 검색은 빈 문자열 유지
                filter: '',
                excludeTestHospital: false,
                dateRange: []
            },
            loading: false,
            // 페이징 데이터
            current: 1,            // 현재 페이지
            pageSize: 10,          // 페이지당 항목 수
            total: 0,              // 전체 항목 수
    
            // 동의서 목록 데이터
            contractList: [],
    
            // 로딩 상태
            isCheckboxVisible: false,
            paginationData: {
                currentPage: 1,
                totalPages: 0,
            },
            baseColumns: [
                {
                    title: '병원명',
                    dataIndex: 'hospitalName',
                    key: 'hospitalName',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '환자명',
                    dataIndex: 'patientName',
                    key: 'patientName',
                    width: 120,
                    align: 'center'
                },
                {
                    title: '환자 연락처',
                    dataIndex: 'patientPhone',
                    key: 'patientPhone',
                    width: 150,
                    align: 'center',
                    customRender: ({text}) => {
                        return phoneNumberFormatter(text);
                    }
                },
                {
                    title: '병원 담당자 연락처',
                    dataIndex: 'hospitalPhone',
                    key: 'hospitalPhone',
                    width: 150,
                    align: 'center',
                    customRender: ({text}) => {
                        return phoneNumberFormatter(text);
                    }
                },
                {
                    title: '시술 종류',
                    dataIndex: 'treatmentType',
                    key: 'treatmentType',
                    width: 150,
                    align: 'center'
                },
                {
                    title: '시술 예정일',
                    dataIndex: 'treatmentDate',
                    key: 'treatmentDate',
                    width: 120,
                    align: 'center'
                },
                {
                    title: () => (
                    <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                        동의서 상태
                        <a-tooltip title="신규 작성 완료 시 서명 대기 중, 서명이 완료되면 서명 완료로 자동 변경됩니다.">
                            <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', cursor: 'help' }} />
                        </a-tooltip>
                    </div>
                    ),
                    dataIndex: 'status',
                    key: 'status',
                    width: 120,
                    align: 'center',
                    customRender: ({text}) => {
                        const statusMap = {
                            CONTRACT_CREATED: {text: '서명 대기 중', color: 'warning'},
                            SIGNATURE_CONCLUDED: {text: '서명 완료', color: 'success'},
                        };
                        const status = statusMap[text] || {text: text, class: ''};
                        return <a-tag color={status.color}>{status.text}</a-tag>;
                    }
                },
                {
                    dataIndex: 'createAt',
                    key: 'createAt',
                    width: 180,
                    align: 'center',
                    title: () => (
                        <div style="display: flex; align-items: center; justify-content: center; gap: 4px;">
                            작성일시
                            <a-tooltip title="시스템을 통해 동의서를 생성한 시간">
                                <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', cursor: 'help' }} />
                            </a-tooltip>
                        </div>
                    ),
                    customRender: ({text}) => {
                        return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '-';
                    }
                },
            ]
        }
    },
    async mounted() {
        await this.handleSearch();
    },
    watch: {
        'searchForm.status'() {
            this.handleSearch();
        },
        'searchForm.excludeTestHospital'() {
            this.handleSearch();
        },
        // 날짜 변경 감지
        dateRange() {
            this.handleSearch();
        },
    },
    methods: {
        handleDateChange(dates) {
            this.dateRange = dates;
            this.handleSearch();
        },
        async fetchContracts() {
            try {
                this.loading = true;
                const params = {
                    page: this.paginationData.currentPage,
                    limit: this.pageSize,
                    status: this.searchForm.status,
                    keyword: this.searchForm.keyword,
                    startDate: this.searchForm.dateRange?.[0]?.format('YYYY-MM-DD') || undefined,
                    endDate: this.searchForm.dateRange?.[1]?.format('YYYY-MM-DD') || undefined
                };

                if(this.searchForm.filter) {
                    params.filter = this.searchForm.filter;
                }

                if(this.searchForm.excludeTestHospital) {
                    params.excludeTestCompany = 'true';
                }
                
                const response = await PrixContractApi.getConsentContracts(params);
        
                if (response?.data?.items) {
                    this.contractList = response.data.items;
                    this.total = response.data.total;
                    // 페이지네이션 데이터 업데이트
                    this.paginationData.totalPages = Math.ceil(this.total / this.pageSize);
                } else {
                    this.contractList = [];
                    this.total = 0;
                    this.paginationData.totalPages = 0;
                }
            } catch (error) {
                console.error('동의서 목록 조회 실패:', error);
                this.contractList = [];
                this.total = 0;
                this.paginationData.totalPages = 0;
            } finally {
                this.loading = false;
            }
        },

        // 검색 처리
        handleSearch() {
            if (this.searchForm.keyword) {
                this.searchForm.keyword = this.searchForm.keyword.trim();
            }
            this.paginationData.currentPage = 1;  // 검색 시 첫 페이지로 이동
            this.fetchContracts();
        },
        handleSizeChange(value) {
            this.pageSize = value;
            this.paginationData.currentPage = 1; // 페이지 사이즈 변경시 첫 페이지로 이동
            this.fetchContracts();
        },
        // 초기화 처리
        handleReset() {
            this.searchForm.status = null;
            this.searchForm.keyword = '';
            this.searchForm.filter = '';
            this.searchForm.excludeTestHospital = false;
            this.searchForm.dateRange = [];
            this.current = 1;
            this.fetchContracts();
        },
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.fetchContracts();
        },
    }
});
</script>
  
<style lang="scss" scoped>
    .consent-contract-container {
        padding: 20px;
  
        .search-filter-container {
            background-color: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            margin-bottom: 16px;
        
            
            .init-btn {
                height: 36px;
                color: rgb(75, 81, 88);
                display: flex;
                align-items: center;
                border: none;
                font-size: 14px;
                font-weight: 600;
                line-height: 1em;
                border-radius: 6px;
                background-color: rgb(221, 224, 228);
            }
  
            .search-filter-row {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #f0f0f0;
        
                &:last-child {
                    border-bottom: none;
                }
  
                .search-filter-title {
                    width: 120px;
                    padding: 6px 12px;
                    background-color: #f7f7f7;
                    color: #555;
                    font-weight: 500;
                    font-size: 14px;
                    border-radius: 4px;
                    text-align: center;
                    margin-right: 16px;
                }
    
                .search-filter-content {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 8px;
        
                    &.search-keyword-area {
                        display: flex;
                        gap: 8px;
            
                        .search-input-container {
                            width: auto;
                            display: inline-flex;
                        }
                    }
        
                    .search-input-container {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        border: 1px solid #d9d9d9;
                        border-radius: 6px;
                        padding: 0 12px;
                        background-color: #fff;
                        max-width: 220px;
            
                        .search-icon {
                            color: #bfbfbf;
                            margin-right: 8px;
                        }
            
                        .search-input-text {
                            border: none;
                            box-shadow: none;
                
                            &:focus {
                                box-shadow: none;
                            }
                        }
                    }
                }
            }
        }
  
        .result-control-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
    
            .left-area {
                display: flex;
                align-items: center;
                gap: 12px;
        
                .total-count {
                    font-size: 15px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    .number-highlight {
                        color: #278aec;
                        font-weight: bold;
                    }
                }
            }
        
            .right-area {
                display: flex;
                gap: 8px;
        
                .btn-create {
                    i {
                        margin-right: 4px;
                    }
                }
            }
        }
    
        .contract-list-wrapper {
            margin-bottom: 16px;
        
            :deep(.ant-table-thead > tr > th) {
                text-align: center !important;
                background-color: #f8f9fa;
                font-weight: 500;
            }
        
            :deep(.ant-table-tbody > tr > td) {
                text-align: center !important;
            }
        
            :deep(.ant-table-cell) {
                padding: 12px !important;
            }
        
            :deep(.ant-btn-link) {
                padding: 4px 0;
                height: auto;
                line-height: 1;
            }
    
            :deep(.table-inside-btn) {
                height: 22px !important;
                padding: 0 8px !important;
                line-height: 20px !important;
                font-size: 12px !important;
            }
        }
    }
</style>
  